import { render } from "./PartnerView.vue?vue&type=template&id=3cc97978&scoped=true"
import script from "./PartnerView.vue?vue&type=script&lang=js"
export * from "./PartnerView.vue?vue&type=script&lang=js"

import "./PartnerView.vue?vue&type=style&index=0&id=3cc97978&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc97978"]])

export default __exports__